import { useQuery } from '@tanstack/react-query';
import { pdfStatusCount } from '@/api/core/sdk.gen';
import { useAuth } from '@/context/AuthContext';
import { usePermissions } from '@/hooks/usePermissions';

export function usePdfStatusCount() {
  const { token } = useAuth();
  const { isAdmin } = usePermissions();

  const { data, isLoading } = useQuery({
    queryKey: ['pdf-status', 'count'],
    queryFn: async () => {
      const { data } = await pdfStatusCount({ throwOnError: true });
      return data;
    },
    enabled: !!token && isAdmin(),
    refetchInterval: 60_000,
    retry: false,
  });

  return {
    pending: data?.pending ?? 0,
    failed: data?.failed ?? 0,
    count: data?.total ?? 0,
    isLoading,
  };
}
